export default "__VITE_ASSET__BffCS98S__"